export default {
    state: {
        showLeftSlider: true,
        showHeader: false,
        showAllPage: false,
        balanceIndex: 0,
        userInfo: null,
        sendCodeCount:120,
        showAdvert:false
    },
    mutations:{
        updateShowLeftSlider (state, showLeftSlider) {
            state.showLeftSlider = showLeftSlider
        },
        updateShowHeader (state, showHeader) {
            state.showHeader = showHeader
        },
        updateShowAllPage (state, showAllPage) {
            state.showAllPage = showAllPage
        },
        updateBalanceIndex(state, balanceIndex) {
            state.balanceIndex = balanceIndex
        },
        updateUserInfo(state, userInfo) {
            state.userInfo = userInfo
        },
        updateSendCodeCountState: (state, sendCodeCount) => {
            state.sendCodeCount = sendCodeCount;
        },
        updateShowAdvert (state, showAdvert) {
            state.showAdvert = showAdvert
        }
    },
    // 类似computed
    getters: {

    },
    actions: {
        setShowLeftSlider ({commit}, showLeftSlider) {
            commit('updateShowLeftSlider', showLeftSlider)
        },
        setShowAllPage ({commit}, showAllPage) {
            commit('updateShowAllPage', showAllPage)
        },
        setBalanceIndex ({commit}, balanceIndex) {
            commit('updateBalanceIndex', balanceIndex)
        },
        setUserInfo ({commit}, userInfo) {
            commit('updateUserInfo', userInfo)
        },
        setShowHeader ({commit}, showHeader) {
            commit('updateShowHeader', showHeader)
        },
        setShowAdvert ({commit}, showAdvert) {
            commit('updateShowAdvert', showAdvert)
        }
    }
}
